// Geography data — extracted verbatim from partners-portal.jsx. Pure data.
// COUNTRY_FLAGS: country name -> ISO 3166-1 alpha-2. WORLD_GEOGRAPHY: countries by continent.

export const COUNTRY_FLAGS = {
  // North America
  'United States': 'US', 'Canada': 'CA', 'Mexico': 'MX', 'Guatemala': 'GT',
  'Belize': 'BZ', 'Honduras': 'HN', 'El Salvador': 'SV', 'Nicaragua': 'NI',
  'Costa Rica': 'CR', 'Panama': 'PA', 'Cuba': 'CU', 'Jamaica': 'JM',
  'Haiti': 'HT', 'Dominican Republic': 'DO', 'Puerto Rico': 'PR',
  'Trinidad and Tobago': 'TT', 'Bahamas': 'BS', 'Barbados': 'BB',
  'Saint Lucia': 'LC', 'Grenada': 'GD', 'Antigua and Barbuda': 'AG',
  'Saint Kitts and Nevis': 'KN', 'Dominica': 'DM',
  'Saint Vincent and the Grenadines': 'VC', 'Aruba': 'AW',
  'Cayman Islands': 'KY', 'Bermuda': 'BM',
  // South America
  'Brazil': 'BR', 'Argentina': 'AR', 'Colombia': 'CO', 'Chile': 'CL',
  'Peru': 'PE', 'Venezuela': 'VE', 'Ecuador': 'EC', 'Bolivia': 'BO',
  'Paraguay': 'PY', 'Uruguay': 'UY', 'Guyana': 'GY', 'Suriname': 'SR',
  'French Guiana': 'GF',
  // Europe
  'United Kingdom': 'GB', 'Germany': 'DE', 'France': 'FR', 'Italy': 'IT',
  'Spain': 'ES', 'Netherlands': 'NL', 'Belgium': 'BE', 'Switzerland': 'CH',
  'Austria': 'AT', 'Sweden': 'SE', 'Norway': 'NO', 'Denmark': 'DK',
  'Finland': 'FI', 'Poland': 'PL', 'Czech Republic': 'CZ', 'Hungary': 'HU',
  'Romania': 'RO', 'Bulgaria': 'BG', 'Greece': 'GR', 'Portugal': 'PT',
  'Ireland': 'IE', 'Luxembourg': 'LU', 'Slovakia': 'SK', 'Slovenia': 'SI',
  'Croatia': 'HR', 'Serbia': 'RS', 'Ukraine': 'UA', 'Russia': 'RU',
  'Turkey': 'TR', 'Cyprus': 'CY', 'Malta': 'MT', 'Estonia': 'EE',
  'Latvia': 'LV', 'Lithuania': 'LT', 'Iceland': 'IS', 'Albania': 'AL',
  'Bosnia and Herzegovina': 'BA', 'Montenegro': 'ME', 'North Macedonia': 'MK',
  'Moldova': 'MD', 'Belarus': 'BY', 'Kosovo': 'XK', 'Liechtenstein': 'LI',
  'Monaco': 'MC', 'San Marino': 'SM', 'Andorra': 'AD', 'Gibraltar': 'GI',
  // Middle East
  'Israel': 'IL', 'United Arab Emirates': 'AE', 'Saudi Arabia': 'SA',
  'Qatar': 'QA', 'Kuwait': 'KW', 'Bahrain': 'BH', 'Oman': 'OM',
  'Jordan': 'JO', 'Lebanon': 'LB', 'Egypt': 'EG', 'Iraq': 'IQ',
  'Iran': 'IR', 'Syria': 'SY', 'Yemen': 'YE', 'Palestine': 'PS',
  // Africa
  'South Africa': 'ZA', 'Nigeria': 'NG', 'Kenya': 'KE', 'Ethiopia': 'ET',
  'Ghana': 'GH', 'Tanzania': 'TZ', 'Uganda': 'UG', 'Morocco': 'MA',
  'Tunisia': 'TN', 'Algeria': 'DZ', 'Libya': 'LY', 'Senegal': 'SN',
  'Ivory Coast': 'CI', 'Cameroon': 'CM', 'Angola': 'AO', 'Mozambique': 'MZ',
  'Zimbabwe': 'ZW', 'Rwanda': 'RW', 'Botswana': 'BW', 'Namibia': 'NA',
  'Zambia': 'ZM', 'Mali': 'ML', 'Burkina Faso': 'BF', 'Niger': 'NE',
  'Chad': 'TD', 'Sudan': 'SD', 'South Sudan': 'SS', 'Somalia': 'SO',
  'Madagascar': 'MG', 'Malawi': 'MW', 'Lesotho': 'LS', 'Eswatini': 'SZ',
  'Gabon': 'GA', 'Republic of the Congo': 'CG',
  'Democratic Republic of the Congo': 'CD', 'Central African Republic': 'CF',
  'Equatorial Guinea': 'GQ', 'Djibouti': 'DJ', 'Eritrea': 'ER',
  'Mauritius': 'MU', 'Seychelles': 'SC', 'Cape Verde': 'CV',
  'Comoros': 'KM', 'São Tomé and Príncipe': 'ST', 'Benin': 'BJ',
  'Togo': 'TG', 'Guinea': 'GN', 'Sierra Leone': 'SL', 'Liberia': 'LR',
  'Guinea-Bissau': 'GW', 'The Gambia': 'GM',
  // Asia Pacific
  'China': 'CN', 'Japan': 'JP', 'South Korea': 'KR', 'India': 'IN',
  'Singapore': 'SG', 'Australia': 'AU', 'New Zealand': 'NZ', 'Hong Kong': 'HK',
  'Taiwan': 'TW', 'Indonesia': 'ID', 'Malaysia': 'MY', 'Thailand': 'TH',
  'Vietnam': 'VN', 'Philippines': 'PH', 'Pakistan': 'PK', 'Bangladesh': 'BD',
  'Sri Lanka': 'LK', 'Nepal': 'NP', 'Myanmar': 'MM', 'Cambodia': 'KH',
  'Laos': 'LA', 'Brunei': 'BN', 'Papua New Guinea': 'PG', 'Fiji': 'FJ',
  'Mongolia': 'MN', 'Maldives': 'MV', 'Timor-Leste': 'TL',
  'Solomon Islands': 'SB', 'Vanuatu': 'VU', 'Samoa': 'WS', 'Tonga': 'TO',
  'Kiribati': 'KI', 'Micronesia': 'FM', 'Palau': 'PW',
  'Marshall Islands': 'MH', 'Nauru': 'NR', 'Tuvalu': 'TV',
  'Afghanistan': 'AF', 'Bhutan': 'BT',
  // Central Asia
  'Kazakhstan': 'KZ', 'Uzbekistan': 'UZ', 'Azerbaijan': 'AZ', 'Georgia': 'GE',
  'Armenia': 'AM', 'Turkmenistan': 'TM', 'Kyrgyzstan': 'KG', 'Tajikistan': 'TJ',
};

export const WORLD_GEOGRAPHY = {
  'North America': [
    'United States', 'Canada', 'Mexico', 'Guatemala', 'Belize', 'Honduras',
    'El Salvador', 'Nicaragua', 'Costa Rica', 'Panama', 'Cuba', 'Jamaica',
    'Haiti', 'Dominican Republic', 'Puerto Rico', 'Trinidad and Tobago',
    'Bahamas', 'Barbados', 'Saint Lucia', 'Grenada', 'Antigua and Barbuda',
    'Saint Kitts and Nevis', 'Dominica', 'Saint Vincent and the Grenadines',
    'Aruba', 'Cayman Islands', 'Bermuda',
  ],
  'South America': [
    'Brazil', 'Argentina', 'Colombia', 'Chile', 'Peru', 'Venezuela',
    'Ecuador', 'Bolivia', 'Paraguay', 'Uruguay', 'Guyana', 'Suriname',
    'French Guiana',
  ],
  'Europe': [
    'United Kingdom', 'Germany', 'France', 'Italy', 'Spain', 'Netherlands',
    'Belgium', 'Switzerland', 'Austria', 'Sweden', 'Norway', 'Denmark',
    'Finland', 'Poland', 'Czech Republic', 'Hungary', 'Romania', 'Bulgaria',
    'Greece', 'Portugal', 'Ireland', 'Luxembourg', 'Slovakia', 'Slovenia',
    'Croatia', 'Serbia', 'Ukraine', 'Russia', 'Turkey', 'Cyprus', 'Malta',
    'Estonia', 'Latvia', 'Lithuania', 'Iceland', 'Albania', 'Bosnia and Herzegovina',
    'Montenegro', 'North Macedonia', 'Moldova', 'Belarus', 'Kosovo',
    'Liechtenstein', 'Monaco', 'San Marino', 'Andorra', 'Gibraltar',
  ],
  'Middle East': [
    'Israel', 'United Arab Emirates', 'Saudi Arabia', 'Qatar', 'Kuwait',
    'Bahrain', 'Oman', 'Jordan', 'Lebanon', 'Egypt', 'Iraq', 'Iran',
    'Syria', 'Yemen', 'Palestine',
  ],
  'Africa': [
    'South Africa', 'Nigeria', 'Kenya', 'Ethiopia', 'Ghana', 'Tanzania',
    'Uganda', 'Morocco', 'Tunisia', 'Algeria', 'Libya', 'Senegal',
    'Ivory Coast', 'Cameroon', 'Angola', 'Mozambique', 'Zimbabwe',
    'Rwanda', 'Botswana', 'Namibia', 'Zambia', 'Mali', 'Burkina Faso',
    'Niger', 'Chad', 'Sudan', 'South Sudan', 'Somalia', 'Madagascar',
    'Malawi', 'Lesotho', 'Eswatini', 'Gabon', 'Republic of the Congo',
    'Democratic Republic of the Congo', 'Central African Republic',
    'Equatorial Guinea', 'Djibouti', 'Eritrea', 'Mauritius', 'Seychelles',
    'Cape Verde', 'Comoros', 'São Tomé and Príncipe', 'Benin', 'Togo',
    'Guinea', 'Sierra Leone', 'Liberia', 'Guinea-Bissau', 'The Gambia',
  ],
  'Asia Pacific': [
    'China', 'Japan', 'South Korea', 'India', 'Singapore', 'Australia',
    'New Zealand', 'Hong Kong', 'Taiwan', 'Indonesia', 'Malaysia',
    'Thailand', 'Vietnam', 'Philippines', 'Pakistan', 'Bangladesh',
    'Sri Lanka', 'Nepal', 'Myanmar', 'Cambodia', 'Laos', 'Brunei',
    'Papua New Guinea', 'Fiji', 'Mongolia', 'Maldives', 'Timor-Leste',
    'Solomon Islands', 'Vanuatu', 'Samoa', 'Tonga', 'Kiribati',
    'Micronesia', 'Palau', 'Marshall Islands', 'Nauru', 'Tuvalu',
    'Afghanistan', 'Bhutan',
  ],
  'Central Asia': [
    'Kazakhstan', 'Uzbekistan', 'Azerbaijan', 'Georgia', 'Armenia',
    'Turkmenistan', 'Kyrgyzstan', 'Tajikistan',
  ],
};
